import { Controller } from 'stimulus';

export default class extends Controller {
    static targets = [ 'res', 'nearby', 'resTab', 'nearbyTab' ];

    connect() {
    }

    showResidences() {
        this.resTarget.classList.remove('hidden');
        this.nearbyTarget.classList.add('hidden');

        this.resTabTarget.classList.add('bg-brand');
        this.resTabTarget.classList.add('text-white');
        this.nearbyTabTarget.classList.remove('bg-brand');
        this.nearbyTabTarget.classList.remove('text-white');
    }
    showNearby() {
        this.nearbyTarget.classList.remove('hidden');
        this.resTarget.classList.add('hidden');

        this.nearbyTabTarget.classList.add('bg-brand');
        this.nearbyTabTarget.classList.add('text-white');
        this.resTabTarget.classList.remove('bg-brand');
        this.resTabTarget.classList.remove('text-white');
    }

};
